/* eslint-disable */
(function($) {

	$( window ).load( function() {
		// Ensure we have an indicator input.
		var checkBox = $('.block--indicator input');

		// Return if we don't have any on the page.
		if ( ! checkBox ) {
			return;
		}

		// Watch checkbox for c hange and enable next button if checked.
		checkBox.change(function() {
				$('.indicator__set--footer button').attr('disabled', ! checkBox.filter(':checked').length);
		});
	});

})(jQuery);
